import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { DataUtil } from "../base/DataUtil";
import { BaseServerData } from "../base/IData";

export abstract class CoreData extends DataUtil {

    protected data: BaseServerData;

    constructor(){ super() }

    public apply(data: BaseServerData):void { 
        this.data = data;
    }

    public isWinBelowStake(): boolean { Logger.warn("isWinBelowStake : Is not Replaced!"); return false;};
    public isIndiviWinBelowStake(): boolean { Logger.warn("isWinBelowStake : Is not Replaced!"); return false;};
}
